import { ChildProps } from '@apollo/client/react/hoc';
import React from 'react';
import { MParticleEventName } from '../../elog/mparticle_types';
import { reverb_search_CSPSearchRequest_Sort, CoreAdEndedListingPage } from '../../gql/graphql';
import { useViewTracking } from '../../use_tracking';
import { withGraphql } from '../../with_graphql';
import { adEndedListingPageQueryGql } from './ad_fragments';
import AdWithCspsRow, { hasAdWithCspsRowRequiredFields, CSP_MAX_COUNT_DEFAULT, AdBannerFallBack } from './ad_with_csps_row';

interface ExternalProps {
  categoryUuids: string[];
}
type Props = ChildProps<ExternalProps, CoreAdEndedListingPage.Query>;

const adQuery = withGraphql<Props, CoreAdEndedListingPage.Query, CoreAdEndedListingPage.Variables>(adEndedListingPageQueryGql,
  {
    options: (ownProps) => {
      return {
        ssr: false,
        variables: { categories: ownProps.categoryUuids },
      };
    },
  },
);

const COMPONENT_NAME = 'AdWithCspsRowContainer';

export function AdWithCspsRowContainer(props: Props) {
  const shouldRender = !props.data?.loading && !!props.data?.adServe?.ad?.imageAdCreative;

  useViewTracking({
    eventName: MParticleEventName.EndedListingPageAdView,
    componentName: COMPONENT_NAME,
  }, shouldRender);

  if (!shouldRender) {
    return null;
  }

  const { ad } = props.data?.adServe ?? {};
  const { imageAdCreative } = ad;
  const { cspRowQuery } = imageAdCreative;

  // If the Ad is not setup with the required fields for a CSP Query
  // show the Ad Banner and do not fire a CSP search.
  if (!hasAdWithCspsRowRequiredFields(ad)) {
    return (
      <AdBannerFallBack ad={ad} />
    );
  }

  return (
    <AdWithCspsRow
      ad={ad}
      cspSlugs={cspRowQuery?.cspSlugs}
      brandSlugs={cspRowQuery?.brandSlugs}
      sort={reverb_search_CSPSearchRequest_Sort[cspRowQuery?.sort]}
      categoryUuids={cspRowQuery?.categoryUuids}
      maxCount={CSP_MAX_COUNT_DEFAULT}
      ssr={false}
    />
  );
}

export default adQuery(AdWithCspsRowContainer);
